// Auto generated file, do not manually modify!
// com.hotpads.customeranalytics.api.web.external.portalanalytics.PortalAnalyticsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates,
  PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_Path,
  PortalAnalyticsWebApiHandler_getPortfolioAnalytics,
  PortalAnalyticsWebApiHandler_getPortfolioAnalytics_Path,
  PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend,
  PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_Path,
  PortalAnalyticsWebApiHandler_getUserSalesProInfo,
  PortalAnalyticsWebApiHandler_getUserSalesProInfo_Path,
  PortalAnalyticsWebApiHandler_isPilotUser,
  PortalAnalyticsWebApiHandler_isPilotUser_Path,
} from '@zg-rentals/ts-customer-analytics-client';

import type {
  AnalyticsLastUpdatedResponseDto,
  PortfolioAnalyticsRequestDto,
  PortfolioAnalyticsResponseDto,
  SalesforceUserDto,
  SfhAccountLevelSpendRequestDto,
  SfhAccountLevelSpendResponseDto,
} from '@zg-rentals/ts-customer-analytics-client';

export type PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_Options = UseQueryOptions<
  AnalyticsLastUpdatedResponseDto,
  unknown,
  AnalyticsLastUpdatedResponseDto,
  readonly [string]
>;

const PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_GetKey = () =>
  [PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_Path] as const;

export const PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_GetKey(),
    queryFn: () => PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates(httpClient),
  }) as const satisfies QueryOptions;

export const usePortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates = ({
  httpClient,
  ...options
}: Omit<PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_queryOptions({ httpClient }),
    ...options,
  });
};
usePortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates.getKey =
  PortalAnalyticsWebApiHandler_getAnalyticsLastUpdatedDates_GetKey;

export type PortalAnalyticsWebApiHandler_getPortfolioAnalytics_Options = UseQueryOptions<
  PortfolioAnalyticsResponseDto,
  unknown,
  PortfolioAnalyticsResponseDto,
  readonly [string, PortfolioAnalyticsRequestDto]
>;

const PortalAnalyticsWebApiHandler_getPortfolioAnalytics_GetKey = (postData: PortfolioAnalyticsRequestDto) =>
  [PortalAnalyticsWebApiHandler_getPortfolioAnalytics_Path, postData] as const;

export const PortalAnalyticsWebApiHandler_getPortfolioAnalytics_queryOptions = (
  postData: PortfolioAnalyticsRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: PortalAnalyticsWebApiHandler_getPortfolioAnalytics_GetKey(postData),
    queryFn: () => PortalAnalyticsWebApiHandler_getPortfolioAnalytics(postData, httpClient),
  }) as const satisfies QueryOptions;

export const usePortalAnalyticsWebApiHandler_getPortfolioAnalytics = (
  postData: PortfolioAnalyticsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<PortalAnalyticsWebApiHandler_getPortfolioAnalytics_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...PortalAnalyticsWebApiHandler_getPortfolioAnalytics_queryOptions(postData, { httpClient }),
    ...options,
  });
};
usePortalAnalyticsWebApiHandler_getPortfolioAnalytics.getKey =
  PortalAnalyticsWebApiHandler_getPortfolioAnalytics_GetKey;

export type PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_Options = UseQueryOptions<
  Array<SfhAccountLevelSpendResponseDto>,
  unknown,
  Array<SfhAccountLevelSpendResponseDto>,
  readonly [string, SfhAccountLevelSpendRequestDto]
>;

const PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_GetKey = (postData: SfhAccountLevelSpendRequestDto) =>
  [PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_Path, postData] as const;

export const PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_queryOptions = (
  postData: SfhAccountLevelSpendRequestDto,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_GetKey(postData),
    queryFn: () => PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend(postData, httpClient),
  }) as const satisfies QueryOptions;

export const usePortalAnalyticsWebApiHandler_getSfhAccountLevelSpend = (
  postData: SfhAccountLevelSpendRequestDto,
  {
    httpClient,
    ...options
  }: Omit<PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_queryOptions(postData, { httpClient }),
    ...options,
  });
};
usePortalAnalyticsWebApiHandler_getSfhAccountLevelSpend.getKey =
  PortalAnalyticsWebApiHandler_getSfhAccountLevelSpend_GetKey;

export type PortalAnalyticsWebApiHandler_getUserSalesProInfo_Options = UseQueryOptions<
  Array<SalesforceUserDto>,
  unknown,
  Array<SalesforceUserDto>,
  readonly [string]
>;

const PortalAnalyticsWebApiHandler_getUserSalesProInfo_GetKey = () =>
  [PortalAnalyticsWebApiHandler_getUserSalesProInfo_Path] as const;

export const PortalAnalyticsWebApiHandler_getUserSalesProInfo_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: PortalAnalyticsWebApiHandler_getUserSalesProInfo_GetKey(),
    queryFn: () => PortalAnalyticsWebApiHandler_getUserSalesProInfo(httpClient),
  }) as const satisfies QueryOptions;

export const usePortalAnalyticsWebApiHandler_getUserSalesProInfo = ({
  httpClient,
  ...options
}: Omit<PortalAnalyticsWebApiHandler_getUserSalesProInfo_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...PortalAnalyticsWebApiHandler_getUserSalesProInfo_queryOptions({ httpClient }),
    ...options,
  });
};
usePortalAnalyticsWebApiHandler_getUserSalesProInfo.getKey = PortalAnalyticsWebApiHandler_getUserSalesProInfo_GetKey;

export type PortalAnalyticsWebApiHandler_isPilotUser_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string]
>;

const PortalAnalyticsWebApiHandler_isPilotUser_GetKey = () => [PortalAnalyticsWebApiHandler_isPilotUser_Path] as const;

export const PortalAnalyticsWebApiHandler_isPilotUser_queryOptions = ({ httpClient }: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: PortalAnalyticsWebApiHandler_isPilotUser_GetKey(),
    queryFn: () => PortalAnalyticsWebApiHandler_isPilotUser(httpClient),
  }) as const satisfies QueryOptions;

export const usePortalAnalyticsWebApiHandler_isPilotUser = ({
  httpClient,
  ...options
}: Omit<PortalAnalyticsWebApiHandler_isPilotUser_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {}) => {
  return useQuery({
    ...PortalAnalyticsWebApiHandler_isPilotUser_queryOptions({ httpClient }),
    ...options,
  });
};
usePortalAnalyticsWebApiHandler_isPilotUser.getKey = PortalAnalyticsWebApiHandler_isPilotUser_GetKey;
